import Api from '~/config/Api'
const endpoint = Api.booking

export default {
  async book ({
    packageId,
    contactInfo,
    passengers,
    services,
    hasInsurance,
    hasMatchInsurance,
    hasAcceptedExtraordinaryConditions,
    hasAcceptedPremiumUpgrade,
    isResidualSaleBooking,
    coupon,
    comment
  }) {
    const { data, error } = await useApi(endpoint, {
      method: 'POST',
      body: {
        packageId,
        contactInfo,
        passengers,
        services,
        coupon: coupon?.code,
        extra: {
          hasInsurance,
          hasMatchInsurance,
          hasAcceptedExtraordinaryConditions,
          hasAcceptedPremiumUpgrade,
          isResidualSaleBooking,
          comment
        }
      }
    })

    if (error && error.value) {
      throw error.value
    }

    return data
  }
}
